import ResetPasswordForm from '../components/ResetPasswordForm'
import { AuthShell, AuthCard } from '../components/authUi'
import { useStaticPageSeo } from '@/lib/seo'

const ResetPasswordPage = () => {
  useStaticPageSeo('/auth/reset-password')

  return (
    <AuthShell>
      <AuthCard>
        <ResetPasswordForm />
      </AuthCard>
    </AuthShell>
  )
}

export default ResetPasswordPage
